import I18n from 'I18n';
import { LAST_THIRTY_DAYS, TODAY, YESTERDAY } from 'foundations-components/transitional/components/Dates';

// @ts-expect-error no types
import { fromMoment } from 'foundations-components/transitional/utils/SimpleDate';
const daysFromNow = (numDays, constructor = 'userTz') => {
  return fromMoment(I18n.moment[constructor]().add(numDays, 'days'));
};
export const momentToSimpleDate = date => {
  return {
    year: date.year(),
    month: date.month(),
    date: date.date()
  };
};
export const dateStringToSimpleDate = date => {
  return momentToSimpleDate(I18n.moment.utc(date));
};
export const dateStringToUnixString = date => {
  return I18n.moment.utc(date).valueOf();
};
export const simpleDateToDateString = date => {
  return I18n.moment.utc(date).format('YYYY-MM-DD');
};
export const DateFilterOptions = {
  TODAY,
  TOMORROW: {
    presetId: 'TOMORROW',
    getValue: tz => ({
      startDate: daysFromNow(1, tz),
      endDate: daysFromNow(1, tz)
    }),
    getText: () => I18n.text('app.filters.dates.tomorrow')
  },
  NEXT_7_DAYS: {
    presetId: 'NEXT_7_DAYS',
    getValue: tz => ({
      startDate: daysFromNow(0, tz),
      endDate: daysFromNow(7, tz)
    }),
    getText: () => I18n.text('app.filters.dates.next7Days')
  },
  NEXT_30_DAYS: {
    presetId: 'NEXT_30_DAYS',
    getValue: tz => ({
      startDate: daysFromNow(0, tz),
      endDate: daysFromNow(30, tz)
    }),
    getText: () => I18n.text('app.filters.dates.next30Days')
  },
  NEXT_90_DAYS: {
    presetId: 'NEXT_90_DAYS',
    getValue: tz => ({
      startDate: daysFromNow(0, tz),
      endDate: daysFromNow(90, tz)
    }),
    getText: () => I18n.text('app.filters.dates.next90Days')
  },
  NEXT_365_DAYS: {
    presetId: 'NEXT_365_DAYS',
    getValue: tz => ({
      startDate: daysFromNow(0, tz),
      endDate: daysFromNow(365, tz)
    }),
    getText: () => I18n.text('app.filters.dates.next365Days')
  },
  YESTERDAY,
  LAST_7_DAYS: {
    presetId: 'LAST_7_DAYS',
    getValue: tz => ({
      startDate: daysFromNow(-7, tz),
      endDate: daysFromNow(0, tz)
    }),
    getText: () => I18n.text('app.filters.dates.last7Days')
  },
  LAST_30_DAYS: LAST_THIRTY_DAYS,
  LAST_90_DAYS: {
    presetId: 'LAST_90_DAYS',
    getValue: tz => ({
      startDate: daysFromNow(-90, tz),
      endDate: daysFromNow(0, tz)
    }),
    getText: () => I18n.text('app.filters.dates.last90Days')
  },
  LAST_365_DAYS: {
    presetId: 'LAST_365_DAYS',
    getValue: tz => ({
      startDate: daysFromNow(-365, tz),
      endDate: daysFromNow(0, tz)
    }),
    getText: () => I18n.text('app.filters.dates.last365Days')
  }
};
export const DateFilterPresets = {
  future: [DateFilterOptions.TODAY, DateFilterOptions.TOMORROW, DateFilterOptions.NEXT_7_DAYS, DateFilterOptions.NEXT_30_DAYS, DateFilterOptions.NEXT_90_DAYS, DateFilterOptions.NEXT_365_DAYS],
  past: [DateFilterOptions.TODAY, DateFilterOptions.YESTERDAY, DateFilterOptions.LAST_7_DAYS, DateFilterOptions.LAST_30_DAYS, DateFilterOptions.LAST_90_DAYS, DateFilterOptions.LAST_365_DAYS]
};
export const utcToRolloutOffsetLocal = date => {
  // Note: Rollout is set to release at 14:00 UTC+0
  return I18n.moment.utc(date).hours(14).local();
};